export * from './VideoSpecs/const';

export const vAction = 'video';
